import { createFileRoute } from "@tanstack/react-router";
import { AppHeader } from "../../components/app-header";
import { ConnectAi } from "../../components/connect/connect-ai";
import { connect } from "../../copy/connect";

export const Route = createFileRoute("/_authed/connect")({
  component: ConnectPage,
});

function ConnectPage() {
  return (
    <div className="min-h-dvh bg-background">
      <AppHeader />
      <main id="main" className="mx-auto max-w-2xl px-4 pt-8 pb-16 sm:px-6">
        <h1 className="text-2xl font-semibold">{connect.title}</h1>
        <p className="mt-1 mb-6 text-sm text-muted-foreground">{connect.subtitle}</p>
        <div className="rounded-xl border border-border p-4 sm:p-6">
          <ConnectAi />
        </div>
      </main>
    </div>
  );
}

